import * as React from "react";
import LabelCtl from "./input/LabelCtl";
import LookupCtl from "./input/LookupCtl";
import { Deal } from "@testout/testout-commerce/models/hubspot/Deal";
import { ListItem } from "@testout/testout-commerce/models/ListItem";
import Api from "./Api";
import "./AssociatePage.scss";

interface IAssociateProps {
    type?: string;
    dealId?: string;
    dealname?: string;
}

interface IAssociateState {
    errorMessage?: string;
    inProgress?: string;
    associateItemNumber?: string;
    customerNumbers?: string;
    initialValue: string;
    initialized?: boolean;
}

export default class AssociatePage extends React.PureComponent<IAssociateProps, IAssociateState> {
    constructor(props: IAssociateProps) {
        super(props);
        this.state = { initialValue: "" };
    }

    async componentDidMount() {
        let customerNumbers = "";
        var deal = await Api.get<Deal>(`/api/deals/${this.props.dealId}`);
        deal.companies.forEach((value) => {
            if (customerNumbers != "")
                customerNumbers += ",";
            customerNumbers += value.d365_account_number;
        });
        this.setState({ customerNumbers: customerNumbers, initialValue: " ", initialized: true });
    }

    onDoItemSearch = async (value: string, exact?: boolean): Promise<ListItem[]> => {
        if (this.props.type === "quote")
            return exact
                ? [await Api.get<ListItem>(`/api/quotes/${value}/list-item`)]
                : await Api.get<ListItem[]>(`/api/quotes/list-items?search=${encodeURIComponent(value)}&customerNumbers=${this.state.customerNumbers}`);
        return exact
            ? [await Api.get<ListItem>(`/api/orders/${value}/list-item`)]
            : await Api.get<ListItem[]>(`/api/orders/list-items?search=${encodeURIComponent(value)}&customerNumbers=${this.state.customerNumbers}`);
    }

    onAssociateItemChange = (value: string) => {
        this.setState({ associateItemNumber: value });
    }

    // Associate the company with the customer in HubSpot
    associateItem = async () => {
        try {
            this.setState({ errorMessage: "", inProgress: "Associating ${this.props.type}..." });

            if (this.props.dealId) {
                if (this.props.type === "quote")
                    await Api.put<object>(`/api/quotes/${this.state.associateItemNumber}/${this.props.dealId}`, null);
                else
                    await Api.put<object>(`/api/orders/${this.state.associateItemNumber}/${this.props.dealId}`, null);
            }
            this.setState({ inProgress: "" });
            this.closeWindow();
        }
        catch (error: any) {
            this.setState({ errorMessage: `Error while saving customer: ${error.message}`, inProgress: "" });
        }
    }

    closeWindow = () => {
        window.parent.postMessage(JSON.stringify({ action: "CANCEL" }), "*");
    }

    render() {
        if (!this.state.initialized)
            return <div className="page loading"><div className="spinner"></div></div>;

        var label = (this.props.type ?? "order")[0].toUpperCase() + (this.props.type ?? "order").substr(1, 4) + "s";
        return <div className="page AssociatePage">
                   <header>
                       <p>Select the {this.props.type} below to associate with the deal <span className="bold">{this.props.dealname}</span>. 
                          The {this.props.type}s listed below belong to the companies connected to this deal.
                       </p>
                       {(this.state.errorMessage ?? "") != "" && <p className="error">{this.state.errorMessage}</p>}
                   </header>
                   <main>
                       <section className="common">
                           <LabelCtl label={label}>
                               <LookupCtl className="associate" placeholder={this.props.type === "order" ? "Search orders" : "Search quotes"}
                                          disabled={false} value={this.state.associateItemNumber} onSearch={this.onDoItemSearch}
                                          onChange={this.onAssociateItemChange} alwaysOpen={true} minCharsForSearch={1} hideItemValue={true} 
                                          initialSearchValue={this.state.initialValue} />
                           </LabelCtl>
                       </section>
                   </main>

                   <footer>
                       <button className="secondary" onClick={this.closeWindow}>Cancel</button>
                       <button className="primary" onClick={this.associateItem} disabled={!this.state.associateItemNumber}>Associate</button>
                   </footer>

                   {this.state.inProgress &&
                       <div className="saving"><div><div>{this.state.inProgress}</div><div className="spinner"></div></div></div>}
                </div>;
    }
}